import React from 'react';
import { useState } from 'react';
import { MDBInput } from "mdb-react-ui-kit";

// reactstrap components
import { Col, Card, CardBody, Row, Form, Label, FormGroup , Input , UncontrolledTooltip , Button  } from "reactstrap";

import axios from 'axios';
import {IVR_CREATE_CALLFLOW} from "../../constants";
import NotificationAlert from "react-notification-alert";
let initialValues ={
  ivrCallflowname:"",
  callFlowfile:"",

}
const CreateCallflow = () => {
  const [ivrCallflow,setIvrCallflow] = useState(initialValues)
  const [validation,setValidation] = useState({isvalid:false,message:""})
  const notificationAlertRef = React.useRef(null);

  const chooseFile=(e)=>{
    let a = e.target.value.split(".");
   
    if(a[1]=="xlsx" || a[1]=="csv"){
      setValidation({
        isvalid:false,
        message: " "
      })
      setIvrCallflow({...ivrCallflow,callFlowfile:e.target.files[0]})
    }else{
      setValidation({
        isvalid:true,
        message: "Not Supported "+a[1]+" format"
      })
      
    }
    
  }
  console.log(ivrCallflow);

  const submitIvr =()=>{
  
    
    const formData = new FormData();
    formData.append('uploaded_file', ivrCallflow.callFlowfile);
    formData.append('callflow_name',  ivrCallflow.ivrCallflowname);
    
   
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    console.log(formData);
    axios.post(IVR_CREATE_CALLFLOW, formData, config).then((response) => {
      let options = {};
      options = {
        place: "tr",
        message: "Saved Successfully",
        type: "success",

        autoDismiss: 2,
      };
      setIvrCallflow(initialValues)
      notificationAlertRef.current.notificationAlert(options);
     // history.push('/ivrcampaignlist')
      console.log("success",response.data)})
      .catch(err=>console.log("err==>",err));
      
    }
  


  return (
    <>
      <div className='content'>
      <Card>
        <CardBody>
        <NotificationAlert ref={notificationAlertRef} />
        <Form >
          <Row>
          <Col className="mt-4" md="3">
      <MDBInput
                    label="Callflow Name"
                    type="text"
                    name="name"
                    value={ivrCallflow.ivrCallflowname}
                     onChange={(e) =>setIvrCallflow({...ivrCallflow,ivrCallflowname:e.target.value})}
                  />
        </Col>
        <Col md="4" sm='4'>
                   
                    <Label >Bulk Upload (<b>Upload Excel and CSV File</b>)</Label>
                    
                      <FormGroup>
                        <Input placeholder="placeholder" accept=".xlsx, .xls, .csv"  onChange ={(e)=>chooseFile(e)} type="file" style={{"opacity" : "1", "position": "initial", "border" : "solid 1px #eee"}}/>
                      </FormGroup>
                      {
                        validation.isvalid&&<span style={{color:"red"}}>{validation.message}</span>
                      }
                  
                    </Col>
                    <Col md='3' sm='3'>
                  <Button 
                    color="primary "
                    className="mt-4 btn btn-icon animation-on-hover"
                    id="tooltipsubmit"
                    type="button"
                    onClick={()=>submitIvr()}
                  ><i className="tim-icons icon-double-right"   /></Button>
                  <UncontrolledTooltip
                  delay={0}
                  placement="top"
                  target="tooltipsubmit"
                >
                  Submit
                </UncontrolledTooltip>
                  </Col>
          </Row>
        </Form>
      
        </CardBody>
        </Card>
      </div>
    </>
  )
}

export default CreateCallflow
